import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const isTopMenuCollapsedStateSlice = createSlice({
	name: 'isTopMenuCollapsedState',
	initialState,
	reducers: {
		setIsTopMenuCollapsedState: (state, action: PayloadAction<boolean>) => {
			return action.payload;
		}
	}
});

export const { setIsTopMenuCollapsedState } = isTopMenuCollapsedStateSlice.actions;

export default isTopMenuCollapsedStateSlice.reducer;
